import { render, staticRenderFns } from "./StatusQuantity.vue?vue&type=template&id=17367aba&scoped=true"
import script from "./StatusQuantity.vue?vue&type=script&lang=js"
export * from "./StatusQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17367aba",
  null
  
)

export default component.exports